import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=2194e298&"
import script from "./Players.vue?vue&type=script&lang=js&"
export * from "./Players.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports